import {metadaApi} from '@dms/api/base';

import {
  PostMazdaPortalLoginApiArg,
  PostMazdaPortalLoginApiArgSchema,
  PostMazdaPortalLoginApiResponse,
  PostMazdaPortalLoginApiResponseSchema,
} from './types';

const metadaMazdaIntegrationApi = metadaApi.injectEndpoints({
  endpoints: (build) => ({
    postMazdaPortalLogin: build.query<PostMazdaPortalLoginApiResponse, PostMazdaPortalLoginApiArg>({
      query: (queryArg) => ({
        url: `/mazda_omn/v1/login`,
        method: 'POST',
        body: queryArg,
      }),
      keepUnusedDataFor: 0,
      extraOptions: {
        responseSchema: PostMazdaPortalLoginApiResponseSchema,
        requestSchema: PostMazdaPortalLoginApiArgSchema,
      },
    }),
  }),
});

export const {usePostMazdaPortalLoginQuery} = metadaMazdaIntegrationApi;
